import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { propertyManagement_template } from "../components/templates/propertyManagement_template";

declare var ko: any;
declare var page: any;

export class propertyManagement extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected propertyManagement_template: propertyManagement_template;

    protected getModuleName(){

        return "propertyManagement";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        // create the propertyManagement list
        this.propertyManagement_template = new propertyManagement_template("propertyManagement", this.viewModel, this);
        this.template = this.propertyManagement_template;

        return [...parentContent, this.propertyManagement_template.build()];
    }

    fillPage() : void{

        this.getPermissions();
        this.getSearchPresetsListData();
    }

    protected getPermissions(){

        this.loadingIn(this.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));
                obj.propertyManagement_template.setSideMenuPermissionsData(responseParsed);
            })

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));
                }
            }
        }
    }

    protected getListFormData(): void{

        this.loadingIn(this.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));

        let subViewModel = this.propertyManagement_template.getViewModelForRequest();

        let usrReq_url: string = '/api/settings/property/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));
                }
            }
        }
    }

    public getListData(): void{

        this.loadingIn(this.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));

        let subViewModel = this.propertyManagement_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/property/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onSubmitEdit(){

        this.loadingIn(this.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));

        let subViewModel = this.propertyManagement_template.getViewModelForRequest();

        let propertyManagementReq_url: string = '/api/settings/property/update';
        let propertyManagementReq_params: Array<Array<string>> = [];
        propertyManagementReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(propertyManagementReq_url, propertyManagementReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdatePropertyManagementReturn;
        this.XHRHdl.execute();
    }

    protected onSubmitCreate(){

        let subViewModel = this.propertyManagement_template.getViewModelForRequest();

        let propertyManagementReq_url: string = '/api/settings/property/create';
        let propertyManagementReq_params: Array<Array<string>> = [];
        propertyManagementReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(propertyManagementReq_url, propertyManagementReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdatePropertyManagementReturn;
        this.XHRHdl.execute();
    }

    protected onUpdatePropertyManagementReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.propertyManagement_template.clearErrors();

                let responseParsed = JSON.parse(req.request.response);

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                // custom error handling
                if (responseParsed.validationErrors) {

                    obj.updateErrors(responseParsed.validationErrors);
                } else {

                    // success
                    obj.updateProperties(responseParsed.properties);
                    obj.updateFieldsOnSuccess();

                    let notifMessage = '';

                    if (req.url.includes('/create')) {

                        notifMessage = " Your property has been set up!<br> To start tracking, please visit your <b>Account Details</b> page to retrieve your unique tracking code.";
                    } else if (req.url.includes('/update')) {

                        notifMessage = "Property has been updated successfully.";
                    }

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, notifMessage);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.loadingOut(obj.propertyManagement_template.builtTemplate);
                }
            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));
                }
            }
        }
    }

    protected updateErrors(errors){

        this.propertyManagement_template.setErrors(errors);
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateProperties(responseParsed.properties);
            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {
                    // LOADING : ends
                    obj.loadingOut(obj.propertyManagement_template.builtTemplate.querySelector("#propertyManagement-results"));
                }
            }
        };
    }

    protected updateProperties(properties){

        this.propertyManagement_template.setProperties(properties);
    }

    protected updateFieldsOnSuccess(){

        this.propertyManagement_template.setFieldsOnSuccess();
    }

    protected updateDailyUsageData(data){

    }

    protected udateUsageDataTotals(data){

    }

    protected filterSingleGroupSelectorOnChange(){

        this.getListData();
    }

    public filterSimpleOnChange() {

        this.getListData();
    }

    public filterSimpleCancel() {

    }
}



// WEBPACK FOOTER //
// ./js/modules/propertyManagement.ts